<template>
  <div class="wf-article-media-item" v-if="src">
    <div class="wf-article-media-item-image">
      <pc-video-tag
        v-if="src.split('.').pop() == '.mp4'"
        :src="src"
        :type="'video/mp4'"
      />
      <pc-image-tag v-else :src="src" :alt="alt" />
    </div>
    <div class="wf-article-media-item-caption" v-if="caption">
      {{ caption }}
    </div>
  </div>
</template>

<script>
import PcImageTag from "../common/pc-image-tag.vue";
import PcVideoTag from "../common/pc-video-tag.vue";
export default {
  props: {
    caption: {
      default: null
    },
    src: {
      default: null
    },
    alt: {
      default: null
    }
  },
  components: {
    PcVideoTag,
    PcImageTag
  }
};
</script>
